import { PaymentAPI, SetupRecurringPaymentMethodOptions } from '../../typings/Payment'
import {
  SetupRecurringPaymentMethodDocument,
  SetupRecurringPaymentMethodMutation,
  SetupRecurringPaymentMethodMutationVariables,
} from '../../graphql'

const setupRecurringPaymentMethod = async (
  paymentAPI: PaymentAPI,
  { paymentId }: SetupRecurringPaymentMethodOptions,
) => {
  const { data, errors } = (await paymentAPI.apolloClient.mutate<
    SetupRecurringPaymentMethodMutation,
    SetupRecurringPaymentMethodMutationVariables
  >({
    mutation: SetupRecurringPaymentMethodDocument,
    variables: { paymentId },
  })) as { data?: SetupRecurringPaymentMethodMutation; errors?: Array<Error> }

  if (errors && errors.length > 0) {
    throw new Error(errors.map((e) => e.message).join('\n'))
  }

  if (!data) {
    throw new Error('Missing confirm payment data')
  }

  if (data.setupRecurringPaymentMethod.__typename === 'ExpectedErrors') {
    return { error: data.setupRecurringPaymentMethod.errors.map((e) => e.message).join('\n') }
  }

  return { data: data.setupRecurringPaymentMethod }
}

export default setupRecurringPaymentMethod
